import React from 'react';
import Dialog from '@mui/material/Dialog';

import ResetPassword from '../../pages/ResetPasswordAdmin';

const ResetPasswordDialog = ({ open, handleClose, isLoading, onSubmit }) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="change-password-dialog-title"
    aria-describedby="change-password-dialog-description"
    sx={{
      '& .MuiPaper-root': {
        width: { xs: '350px', sm: '649px' },
        height: 'max-content',
        borderRadius: '20PX',
      },
    }}
  >
    <ResetPassword handleClose={handleClose} onSubmit={onSubmit} isLoading={isLoading} />
  </Dialog>
);

export default ResetPasswordDialog;
